import React from 'react';
import { Heading, Button, Box, CircularProgress } from '@chakra-ui/react';
import { ModalDialog } from '../../components/ModalDialog';

import { Answer, Question } from '../../types/interviewResultConfirm';
import { InterviewResultQuestion } from './InterviewResultQuestion';
import { dateConvert } from '../../utils/dateConvert';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  answers: Answer[];
  questions: Question[];
  createdAt: string;
  loading: boolean;
};

export const InterviewResultHistoryDetail: React.VFC<Props> = ({
  isOpen,
  onClose,
  answers,
  questions,
  createdAt,
  loading,
}) => {
  const handleOnClose = () => {
    onClose();
  };

  return (
    <ModalDialog
      header={
        <Heading
          size="lg"
          color="gray.600"
          textAlign="left"
          pb="4"
          borderBottomWidth="1px"
        >
          質問と回答（履歴）
        </Heading>
      }
      body={
        loading ? (
          <CircularProgress isIndeterminate color="blue.300" />
        ) : (
          <Box>
            <Box
              bg="green.50"
              px="2"
              borderWidth="2px"
              borderColor="green.50"
              margin="0 0 0 auto"
              w="fit-content"
            >
              更新日：{dateConvert(createdAt, 'seconds')}
            </Box>
            {questions ? (
              questions.map((q, idx) => (
                <InterviewResultQuestion
                  key={idx}
                  question={q}
                  answers={answers}
                />
              ))
            ) : (
              <></>
            )}
          </Box>
        )
      }
      footer={
        <Button w="30" onClick={handleOnClose}>
          戻る
        </Button>
      }
      isOpen={isOpen}
      onClose={handleOnClose}
      size="2xl"
    />
  );
};
